import QrcodeStream from "./components/QrcodeStream.vue";
import QrcodeCapture from "./components/QrcodeCapture.vue";
import QrcodeDropZone from "./components/QrcodeDropZone.vue";
// Install the components
export function install(app) {
    app.component("qrcode-stream", QrcodeStream);
    app.component("qrcode-capture", QrcodeCapture);
    app.component("qrcode-drop-zone", QrcodeDropZone);
}
// Expose the components
export { QrcodeStream, QrcodeCapture, QrcodeDropZone };
/* -- Plugin definition & Auto-install -- */
/* You shouldn't have to modify the code below */
// Plugin
const plugin = { install };
export default plugin;
let GlobalVue = null;
if (typeof window !== "undefined") {
    GlobalVue = window.Vue ?? null;
}
else {
    const maybeGlobal = globalThis;
    GlobalVue = maybeGlobal.Vue ?? null;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}
